import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const FellowTeacherMeetingsToTrackAttendance = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Fellow-teacher meetings to track attendance" />
    </Box>
  );
};
